import React, { Component } from 'react';
import PropTypes from 'prop-types';
import findIndex from 'lodash/findIndex';
import classnames from 'classnames';

import CheckBox from '../../atoms/CheckBox';
import styles from './styles.scss';

/**
 * Lists an order's items. These items can be checked. Used within the order help to select which
 * item(s) where problematic
 */
export default class OrderHelpItemsSelection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedItems: {},
    };
  }

  onItemChange(event, item, modifier) {
    const adding = event.target.checked;

    let newItem = Object.assign({}, this.state.selectedItems[item.id]);
    if (!newItem.orderItemId) {
      newItem = {
        id: item.id,
        includeMainItem: false,
        orderItemId: item.orderItemId,
        modifiers: [],
      };
    }
    newItem.modifiers = newItem.modifiers.slice(0);

    if (modifier) {
      const index = findIndex(newItem.modifiers, { id: modifier.id });

      if (!adding && index > -1) {
        newItem.modifiers.splice(index, 1);
      } else if (adding) {
        newItem.modifiers = newItem.modifiers.concat({
          id: modifier.id,
          orderItemId: modifier.orderItemId,
        });
      }
    } else {
      newItem.includeMainItem = adding;
    }

    // eslint-disable-next-line react/no-access-state-in-setstate
    let newSelectedItems = Object.assign({}, this.state.selectedItems);
    if (newItem.includeMainItem === false && newItem.modifiers.length === 0) {
      delete newSelectedItems[item.id];
    } else {
      newSelectedItems = Object.assign(newSelectedItems, { [item.id]: newItem });
    }

    this.setState({ selectedItems: newSelectedItems }, () =>
      this.props.onItemsSelection(Object.values(this.state.selectedItems)),
    );
  }

  isItemSelected(itemId) {
    const selectedItems = [];

    Object.keys(this.state.selectedItems).forEach((key) => {
      const item = this.state.selectedItems[key];
      if (item.includeMainItem) {
        selectedItems.push(item.id);
      }
      item.modifiers.forEach((modifier) => {
        selectedItems.push(modifier.id);
      });
    });

    return selectedItems.indexOf(itemId) > -1;
  }

  render() {
    const { items, iframe } = this.props;

    return (
      <div>
        <ul className={classnames(styles.list, { [styles.modal]: iframe })}>
          {items.map((item) => (
            <li
              key={item.id}
              className={classnames(styles.item, { [styles['parent-item']]: !!item.modifiers })}
            >
              <label
                htmlFor={`item-input-${item.id}`}
                className={classnames(styles.label, {
                  [styles.selected]: this.isItemSelected(item.id),
                })}
              >
                <CheckBox
                  onChange={(e) => this.onItemChange(e, item)}
                  id={`item-input-${item.id}`}
                />
                <span className={styles['item-name']}>{item.name}</span>
              </label>
              {item.modifiers && (
                <ul className={styles.nested}>
                  {item.modifiers.map((modifier) => (
                    <li key={modifier.id}>
                      <label
                        htmlFor={`modifier-input-${modifier.id}`}
                        className={classnames(styles.label, {
                          [styles.selected]: this.isItemSelected(modifier.id),
                        })}
                      >
                        <CheckBox
                          onChange={(e) => this.onItemChange(e, item, modifier)}
                          id={`modifier-input-${modifier.id}`}
                        />
                        <span className={styles['item-name']}>{modifier.name}</span>
                      </label>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

OrderHelpItemsSelection.propTypes = {
  /**
   * The list of order items to select
   */
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      modifiers: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
        }),
      ),
      name: PropTypes.string,
    }),
  ).isRequired,
  /**
   * The action to trigger on selecting an item
   */
  onItemsSelection: PropTypes.func.isRequired,
  /**
   * How it should be appropriately styled for either a full page or within a modal
   */
  iframe: PropTypes.bool,
};

OrderHelpItemsSelection.defaultProps = {
  iframe: false,
};
